"use client";

import { useEffect } from "react";
import { errorTracking } from "@/lib/error-tracking";
import { ErrorFallback } from "@/components/error-fallback";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to error tracking service
    errorTracking.logError(error, {
      digest: error.digest,
      source: "app-error-boundary",
    });
  }, [error]);

  return <ErrorFallback error={error} resetError={reset} />;
}